// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ExternalNetworkReachabilityStatusSchema = z.enum(['UNKNOWN','REACHABLE','UNREACHABLE'] as const);

export type ExternalNetworkReachabilityStatusType = `${z.infer<typeof ExternalNetworkReachabilityStatusSchema>}`

export default ExternalNetworkReachabilityStatusSchema;
